import { render, staticRenderFns } from "./ProjectCreate.vue?vue&type=template&id=0d13d06a&scoped=true"
import script from "./ProjectCreate.vue?vue&type=script&lang=js"
export * from "./ProjectCreate.vue?vue&type=script&lang=js"
import style0 from "./ProjectCreate.vue?vue&type=style&index=0&id=0d13d06a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d13d06a",
  null
  
)

export default component.exports